import DialogLayoutV2 from "../common/dialog-layoutV2";

function Dialog({ open, onSave, onClose }) {
  const content = (
    <div className="text-center">
      <div className='text-2xl font-semibold text-gray-800 mb-2'>
        Are you sure you want to go back?
      </div>
      <div className='text-gray-600'>
        You were just charged for this transaction. Are you sure you want to go back?
      </div>
    </div>
  )

  const footerProps = {
    primaryButton: {
      text: "Yes, Back",
      width: '170px',
      height: '50px',
    },
    secondaryButton: {
      text: "Cancel",
      width: '170px',
      height: '50px',
    }
  }

  return (
    <DialogLayoutV2
      open={open}
      text= 'text-[35px]'
      fullScreen={false}
      maxWidth="sm"
      content={content}
      onClose={onClose}
      onSubmit={onSave}
      footerProps={footerProps}
    />
  );
}

export default Dialog;
